import { css } from '@linaria/core';

export const root = css`
  aspect-ratio: 9/14;
  flex: 1;
  width: 100%;
  position: relative;
`;

export const bg = css`
  position: absolute;
  width: 100%;
  aspect-ratio: 9/14;
  border-radius: 0.5rem;
`;
